export const REQUIRED = '@@validations/REQUIRED'
export const EMAIL = '@@validations/EMAIL'
export const PASSWORD = '@@validations/PASSWORD'
export const PHONE_NUMBER = '@@validations/PHONE_NUMBER'
export const URL = '@@validations/URL'
export const MIN_NUMBER = '@@validations/MIN_NUMBER'
export const MIN_30000 = '@validations/MIN_30000'
export const MIN_50000 = '@validations/MIN_50000'

export const NIF_NIE = '@@validations/NIF_NIE'
export const CIF = '@@validations/CIF'

export const ZIP_CODE = '@@validations/ZIP_CODE'

export const IS_TRUE = '@@valiations/IS_TRUE'
export const IS_FALSE = '@@validations/IS_FALSE'

export const IS_VALID_DATE = '@@validations/IS_VALID_DATE'
export const MAX_DATE = '@@validations/MAX_DATE'
export const MIN_DATE = '@@validations/MIN_DATE'
